import { Spin360Viewer } from "../Spin360Viewer/Spin360Viewer";
import { DragHint } from "../DragHint/DragHint";
import { MediaColumn, StaticImage } from "./VehicleMedia.styles";

interface VehicleMediaProps {
  frames: string[];
  cover?: string;
  alt: string;
  maxHeight: { mobile: string; desktop: string };
  hint?: { show: boolean; label: string; color: string };
  resetSignal?: string | number;
  lazy?: boolean;
  dragSensitivity?: number;
  preloadCount?: number;
  autoRotate?: boolean;
  autoRotateSpeed?: number;
}

export const VehicleMedia = ({
  frames,
  cover,
  alt,
  maxHeight,
  hint,
  resetSignal,
  lazy = true,
  dragSensitivity = 8,
  preloadCount = 8,
  autoRotate = false,
  autoRotateSpeed = 10,
}: VehicleMediaProps) => {
  if (frames.length > 1) {
    return (
      <Spin360Viewer
        frames={frames}
        cover={cover}
        lazy={lazy}
        loop
        dragSensitivity={dragSensitivity}
        preloadAll={false}
        preloadCount={preloadCount}
        autoRotate={autoRotate}
        autoRotateSpeed={autoRotateSpeed}
        hint={hint}
        ariaLabel={alt}
        resetSignal={resetSignal}
        maxHeight={maxHeight}
      />
    );
  }

  if (cover) {
    return (
      <MediaColumn>
        <StaticImage
          src={cover}
          alt={alt}
          $maxHMobile={maxHeight.mobile}
          $maxHDesktop={maxHeight.desktop}
        />
        {hint?.show && (
          <DragHint
            label={hint.label}
            color={hint.color}
            placeholder
          />
        )}
      </MediaColumn>
    );
  }

  return null;
};
